import React from 'react';

import Button, { ButtonType } from 'components/Button';
import { RoutePath } from 'enums/Routes';
import { useNavigate } from 'hooks/useNavigate';

import styles from './ConnectAccountsSection.module.scss';

const ConnectAccountsSection: React.FC = () => {
  const navigate = useNavigate();

  const handleConnectAccountsClick = () => {
    analytics.track('Dashboard Connect Accounts Clicked');
    navigate(RoutePath.PlaidCheckingAccounts);
  };

  return (
    <div className={styles.connectAccountsSection}>
      <div className={styles.copy}>
        <h3 className={styles.title}>Connect accounts to track your progress</h3>
        <p className={styles.description}>
          Connect to your accounts and we&apos;ll track your progress toward your goal. If you start falling behind,
          we&apos;ll show you simple ways to catch up.
        </p>
      </div>
      <Button type={ButtonType.Secondary} className={styles.connectButton} onClick={handleConnectAccountsClick}>
        CONNECT ACCOUNTS
      </Button>
    </div>
  );
};

export default ConnectAccountsSection;
